/** * 左边菜单 */
<template>
  <el-menu :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened
    class="el-menu-vertical-demo left-nav" background-color="#193058" text-color="#ffffff" color="#ffffff"
    active-text-color="#ffd04b">
    <el-menu-item :index="MainIndexUrl" v-if="admin" @click="clickMainMenu">
      <i class="el-icon-house"></i>
      <span slot="title">系统门户</span>
    </el-menu-item>
    <el-submenu v-for="menu in listData" :key="menu.keyId" :index="menu.menuName">
      <template slot="title">
        <i :class="menu.menuIcon"></i>
        <span>{{ menu.menuName }}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.subList" :index="chmenu.menuPath.startsWith('/')
          ? chmenu.menuPath
          : '/' + chmenu.menuPath
          " :key="chmenu.keyId" @click="clickMyMenu(chmenu)">
          <template>
            <i :class="chmenu.menuIcon"></i>
            <span>{{ chmenu.menuName }}</span>
          </template>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { GetRoleMenuTreeList } from "../../api/menuApi.js";
import { MyDebounce } from "../../utils/util.js";
export default {
  name: "leftnav",
  data() {
    return {
      admin: false,
      loginName: "",
      collapsed: false,
      hideTitle: true,
      allmenu: [],
      listData: [],
      MainIndexUrl: "",
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.getRoleMenuTree();
    const that = this;
    that.loginName = localStorage.getItem("userdata");
    that.loginName = JSON.parse(that.loginName);
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    if (userdata.roleInfo.keyId == "2f91e757a9c4444dbe13146a363a717c") {
      that.admin = true;
    }
    // 监听
    that.$root.Bus.$on("toggle", (value) => {
      that.collapsed = !value;
    });
    that.$root.Bus.$on("toggle", (value) => {
      that.hideTitle = value;
    });
  },
  methods: {
    // 点击菜单 - 添加防抖处理
    clickMyMenu: MyDebounce(function (menu) {
      if (menu.keyId == "1") {
        this.$refs.menuEdit.editShow();
      } else {
        this.$router.push({
          path: menu.menuPath.startsWith("/")
            ? menu.menuPath
            : "/" + menu.menuPath,
        });
      }
    }, 300),
    getRoleMenuTree() {
      const that = this;
      let userInfo = JSON.parse(localStorage.getItem("userdata"));
      let roleId = userInfo.roleInfo.keyId;
      let param = {
        keyId: roleId,
        menuType: 1,
      };
      GetRoleMenuTreeList(param).then((res) => {
        if (res.code == 1) {
          this.listData = res.data;
        }
      });
    },
    // 点击主菜单 - 添加防抖处理
    clickMainMenu: MyDebounce(function () {
      this.$router.push({
        path: '/exeIndex/mainIndex/workbench'
      })
    }, 300)
  },
};
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 260px;
  height: 100% !important;
  /* min-height: 400px; */
  /* 		background-image: linear-gradient(-90deg,
				#29bdd9 0%,
				#276ace 100%) !important; */
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}

/* 隐藏el-menu纵向滚动条但保持滚动功能 */
.el-menu::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.el-menu::-webkit-scrollbar-track {
  background: transparent;
}

.el-menu::-webkit-scrollbar-thumb {
  background: transparent;
}

/* 确保el-menu内容可滚动 */
.el-menu {
  overflow-y: auto;
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE 和 Edge */
}

/* 如果需要支持所有浏览器，添加以下样式 */
.el-menu {
  -ms-overflow-style: none;
  /* IE 10+ */
  overflow: -moz-scrollbars-none;
  /* Firefox */
}

.el-menu-item-group__title {
  padding: 0 !important;
  display: none;
}

.el-submenu__title i {
  /* color: #151058 !important; */
  color: #ffffff !important;
}

/* .el-menu-bg {
				background-image: linear-gradient(-90deg,
				#29bdd9 0%,
				#276ace 100%) !important;
	} */

.el-menu {
  border: none;
  /* background-image: linear-gradient(-90deg, #29bdd9 0%, #276ace 100%); */
}

.logobox {
  color: #ffffff;
  font-size: 14px;
  display: flex;
  align-items: center;
  padding-top: 5px;
  padding-left: 30px;
}

.logobox img {
  height: 50px;
  width: 180px;
  border: 1px dashed #000;
}

.logobox_s {
  color: #ffffff;
  font-size: 14px;
  display: flex;
  align-items: center;
  padding-top: 5px;
  padding-left: 38px;
}

.logoimg {
  width: 50px;
  height: 50px;
}

.logoimg2 {
  height: 48px;
}

.left-nav .el-menu-item i {
  color: #ffffff !important;
}

.left-nav .el-menu-item.is-active i {
  color: inherit;
}

::v-deep(.el-icon-arrow-down:before) {
  content: "";
  font-size: 18px;
  color: #ffffff;
}
</style>
